import { render, staticRenderFns } from "./AddCategory.vue?vue&type=template&id=42a27240&scoped=true&"
import script from "./AddCategory.vue?vue&type=script&lang=js&"
export * from "./AddCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a27240",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42a27240')) {
      api.createRecord('42a27240', component.options)
    } else {
      api.reload('42a27240', component.options)
    }
    module.hot.accept("./AddCategory.vue?vue&type=template&id=42a27240&scoped=true&", function () {
      api.rerender('42a27240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/CategoriesPage/AddCategory.vue"
export default component.exports